import React from 'react'
import { LRRefund } from '../style/LifetimeReplacement.css'

const EstimatedRefund = ({ item }) => {
  const { itemTotal } = { ...item }
  return (
    <LRRefund>
      <span>
        Estimated Refund:&nbsp;
        <span>
          $
          {parseFloat(itemTotal).toFixed(2)}
        </span>
      </span>
    </LRRefund>
  )
}

export default EstimatedRefund
